<script>
import WorkOrderHelper from "@/utils/workOrderHelper";

export default {
  props: {
    workOrder: {
      type: Object,
      required: true,
    },
    packingIdPublic: {
      type: String,
      default: null,
    },
  },
  methods: {
    fullAddress(workOrder) {
      return WorkOrderHelper.getFullAddress(workOrder);
    },
    gotoworkorder() {
      this.$router.push({
        name: "workOrderProducts",
        params: { workOrderPublicId: this.workOrder.idPublic },
        query: this.packingIdPublic
          ? { packagingPublicId: this.packingIdPublic }
          : {},
      });
    },
  },
};
</script>

<template>
  <div class="work-order-card ">
    <div class="card-body">
      <div class="d-flex">
        <div class="flex-fill">
          <div style="font-size: 1.5em">
            {{ workOrder.name }}
          </div>
          <div class="d-flex" style="font-size: 1.3em">
            <div class="flex-fill text-nowrap">
              <i class="mdi mdi-24px mdi-cube-outline align-middle"></i>
              <span class="p-1 position-relative">
                <b-badge pill variant="primary" class="position-absolute" style="top: 0px; right: -5px;">
                  {{ workOrder.nbProducts }}
                </b-badge>
              </span>
            </div>
            <div class="flex-fill text-nowrap">
              <i class="mdi mdi-24px mdi-puzzle-outline align-middle"></i>
              <span class="p-1 position-relative">
                <b-badge pill variant="primary" class="position-absolute" style="top: 0px; right: -5px;">
                  {{ workOrder.nbDetached }}
                </b-badge>
              </span>
            </div>
            <div class="flex-fill text-nowrap">
              <i class="mdi mdi-24px mdi-alert-outline text-danger align-middle"></i>
              <span class="p-1 position-relative">
                <b-badge pill variant="danger" class="position-absolute" style="top: 0px; right: -5px;">
                  {{ workOrder.nbWarning }}
                </b-badge>
              </span>
            </div>
          </div>
        </div>
        <div class="flex-fill">
          <div class="d-flex flex-row justify-content-end">
            <div role="button" class="p-0 mr-2" @click="$emit('open-files', workOrder)">
              <i class="mdi mdi-24px mdi-file-document-multiple-outline"></i>
            </div>
            <div role="button" class="p-0" v-if="fullAddress(workOrder)">
              <a target="_blank" :href="'http://maps.google.com/?q=' + fullAddress(workOrder)">
                <i class="mdi mdi-24px mdi-map-marker-outline text-success"></i>
              </a>
            </div>
            <div class="p-0" v-if="!fullAddress(workOrder)">
              <i class="mdi mdi-24px mdi-map-marker-outline"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between m-1">
        <div class="d-flex flex-fill justify-content-start">
          <div
            v-for="(workOrderStep, index) in workOrder.workOrderSteps"
            :key="index"
            class="p-1 "
          >
            <span
              class="badge badge-secondary p-2"
              style="font-size: 0.8em"
              v-if="workOrderStep.completedJobsite"
            >
              <i class="mdi mdi-check align-middle"></i>
              {{ workOrderStep.stepName }}
            </span>
            <b-button
              disabled
              role="text"
              v-if="!workOrderStep.completedJobsite"
              variant="outline-primary"
              class="p-1"
              style="font-size: 0.8em"
            >{{ workOrderStep.stepName }}</b-button>
          </div>
        </div>
        <div role="button" @click="gotoworkorder()">
          <span style="text-decoration: underline !important">{{
            $t("general.seeprofile")
          }}</span>
          &#8594;
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          {{ $t("general.abrdeliverydate") }} :
          {{ $dayjs(workOrder.deliveryDate + "Z").format("YYYY-MM-DD") }}
        </div>
        <div>
          {{ $t("general.abrinstallationdate") }} :
          {{ $dayjs(workOrder.installationDate + "Z").format("YYYY-MM-DD") }}
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
    .work-order-card {
      border: 1px solid #dee0e3;
      border-radius: 4px;
    }
  @media (max-width: 450px) {
    .work-order-card {
      
    }
    .card-body {
      padding: 0.5rem 0.5rem;
      border: 0;
    }
  }
</style>
